export default __webpack_public_path__ + "static/media/WOR-interview4.6f61e3f2.png";